import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AuthService } from '../../api/services/auth.service';
import { PreferencesService } from '../../api/services/preferences.service';
import { MarketService } from '../../api/services/market.service';
import { Market } from '../../api/models/market-model';
import { UserService } from '../../api/services/user.service';

@Injectable()
export class MarketBannerService {

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private marketService: MarketService,
    private preferencesService: PreferencesService) { }

  marketBannerObserver = new Subject<Market>();
  market: Market;

  setMarketBanner() {
    setTimeout(() => {
      this.market = null;
      this.getMarketBannerFromService();
    }, 0);
  }

  getMarketBanner() {
    return this.marketBannerObserver.asObservable();
  }

  refreshMarketBanner() {
    this.getMarketBannerFromService();
  }

  private getMarketBannerFromService() {
    this.preferencesService.getPreferences('USER', this.authService.getUserId())
      .subscribe(prefs => {
        if (prefs && prefs['current-market']) {
          var currentMarket = prefs['current-market'].Value;
          if (currentMarket && currentMarket.trim().length > 0) {
            this.marketService.getMarket(currentMarket).subscribe(market => {
              if (market && this.userService.isMarketPermittedForCurrentUser(market.id)) {
                this.market = market;
                this.storeMarketDetailsInLocalStorage(market);
              } else {
                this.market = null;
                this.removeMarketDetailsFromLocalStorage();
              }
              this.marketBannerObserver.next(this.market);
            }, error => {
              this.market = null;
              this.marketBannerObserver.next(this.market);
              this.removeMarketDetailsFromLocalStorage();
            });
          } else {
            this.market = null;
            this.marketBannerObserver.next(this.market);
            this.removeMarketDetailsFromLocalStorage();
          }
        } else {
          this.market = null;
          this.marketBannerObserver.next(this.market);
          this.removeMarketDetailsFromLocalStorage();
        }
      });
  }

  storeMarketDetailsInLocalStorage(market: Market) {
    if (market) {
      localStorage.setItem('marketAccountNo', market.accountNumber);
      localStorage.setItem('marketLocationCode', market.locationCode);
      localStorage.setItem('marketType', market.type != null ? market.type : '');
    }
  }

  removeMarketDetailsFromLocalStorage() {
    localStorage.removeItem('marketAccountNo');
    localStorage.removeItem('marketLocationCode');
    localStorage.removeItem('marketType');
  }

  setMarket(market: Market) {
    if (market && this.userService.isMarketPermittedForCurrentUser(market.id)) {
      this.preferencesService.setPreference('USER', this.authService.getUserId(), 'current-market', { Value: market.id }).subscribe(result => {
        this.marketBannerObserver.next(market);
      });
    } else {
      this.market = null;
      this.marketBannerObserver.next(this.market);
      this.removeMarketDetailsFromLocalStorage();
    }
  }

  setMarketByMarketId(marketId: string) {
    this.marketService.getMarket(marketId).subscribe(market => {
      this.setMarket(market);
    }, error => {
      this.setMarket(null);
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/market-banner/market-banner.service.ts